import { Dropdown } from 'components/ui'
import { AIContext } from 'contexts/AIContext'
import React, { useContext } from 'react'
import { HiChevronDown } from 'react-icons/hi'

const AIVideoDropdownDuration = ({ duration, setDuration, model, className, parentClassName, disabled = false }) => {
    
    const { aiVideoModels } = useContext(AIContext);
    
    const currentModel = aiVideoModels?.find(m => m.model === model);
    const availableDurations = currentModel?.availableDurations;
    
    const durationOptions = availableDurations.map(duration => ({
        id: duration,
        label: `${duration}s`,
        icon: ""
    }));

    const currentDuration = durationOptions.find(d => d.id === duration) || durationOptions[0];

    const Toggle = (
        <div className={`flex items-center justify-center gap-2 ${disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'} ${className}`}>
            <span className="text-lg">{currentDuration?.icon}</span>
            <span className="font-medium">{currentDuration?.label}</span>
            <HiChevronDown className="text-lg" />
        </div>
    );

    return (
        <div className={parentClassName}>
            <Dropdown 
                renderTitle={Toggle}
                placement="bottom-end"
                className="!w-full"
                menuClass="!max-w-[50px] !w-[50px]"
                disabled={disabled}
            >
                {durationOptions.map((durationOption) => (
                    <Dropdown.Item 
                        key={durationOption.id}
                        eventKey={durationOption.id} 
                        onSelect={() => !disabled && setDuration(durationOption.id)}
                        className={`flex items-center justify-center !py-2 !text-center hover:!bg-gray-100 dark:hover:!bg-gray-900/20 gap-3 ${duration === durationOption.id ? 'bg-purple-50 dark:bg-purple-900/20' : ''} ${disabled ? 'cursor-not-allowed opacity-50' : ''}`}
                    >
                        <div className="font-medium">{durationOption.label}</div>
                    </Dropdown.Item>
                ))}
            </Dropdown>
        </div>
    )
}

export default AIVideoDropdownDuration
